var React = require('react');

function ChevronUp (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.848 9.232L8.616 2 1.384 9.232","stroke":"#8AD124","strokeWidth":"2","fill":"none","fillRule":"evenodd"}));
}

ChevronUp.defaultProps = {"width":"17","height":"10"};

module.exports = ChevronUp;

ChevronUp.default = ChevronUp;
